import { render } from "./ComponentToggle.vue?vue&type=template&id=39ccbba0&scoped=true"
import script from "./ComponentToggle.vue?vue&type=script&lang=js"
export * from "./ComponentToggle.vue?vue&type=script&lang=js"

import "./ComponentToggle.vue?vue&type=style&index=0&id=39ccbba0&scoped=true&lang=css"

import exportComponent from "D:\\PhpstormProjects\\alignment-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ccbba0"]])

export default __exports__